import { View, Text, ViewStyle } from "react-native";
import { CheckboxItem } from "../../components";
import { Control, Controller } from "react-hook-form";
import { JobPreferenceField, JobPreferencesFormData } from "./types";

interface JobCategoriesProps {
  control: Control<JobPreferencesFormData>;
  categories: JobPreferenceField[];
  style?: ViewStyle;
}

const JobCategories = ({ control, categories, style }: JobCategoriesProps) => (
  <View className="bg-white py-8" {...{ style }}>
    <Text className="text-large-normal text-ink-darkest font-700 px-6 mb-6">What type of job are you seeking?</Text>
    {categories.map((category) => (
      <Controller
        key={category.value}
        name={`jobCategories.${category.value}`}
        control={control}
        defaultValue={false}
        render={({ field: { onChange, value } }) => (
          <CheckboxItem
            {...{
              labelStyle: "text-regular-tight pl-2",
              position: "trailing",
              label: category.label,
              value,
              onChange,
            }}
          />
        )}
      />
    ))}
  </View>
);

export default JobCategories;
